import { Button, Checkbox, Form, FormField, Input, SelectProps, Table, TimeInput } from '@cloudscape-design/components';
import Box from '@cloudscape-design/components/box';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import React, { useEffect, useState } from 'react';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading } from '../../../../commons/functions';
import { CustomAppLayout } from '../../../layout';
import { useRouter } from '../../../router';
import { useStore } from '../../../store';
const _preserve = React.version;
//import { useStoreAdmin } from '../../../context/useStoreAdmin';
import { mdiAllInclusiveBox, mdiArrowRightThin } from '@mdi/js';
import Icon from '@mdi/react';
import DPModal from '../../../../../components/DPModal';
import BadgeCustom from '../../../../../components/extras/BadgeCustom';
import ConfirmDelete from '../../../../../components/extras/ConfirmDelete';
import Favorites from '../../../../../components/extras/Favorites';
import IconActive from '../../../../../components/extras/IconActive';
import SelectCategory from '../../../../../components/selects/selectCategory';
import SelectEquipments from '../../../../../components/selects/selectEquipments';
import SelectGroupType from '../../../../../components/selects/selectGroupType';
import SelectUserType from '../../../../../components/selects/selectUserTypes';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { btnWarn, weekDays } from '../../../../../resources/types';
import { useGlobalState } from '../../../../context/GlobalStateContext';

const pageSize = 20;
type OptionDefinition = SelectProps.Option;
export const MasterParametersBlockings = () => {
    const { menu } = useGlobalState();

    type OptionDefinition2 = {
        label: string;
        value: string;
    };




    //const storeAdmin = useStoreAdmin();


    const [helpOpen, setHelpOpen] = useState(false);
    const [sideOpen, setSideOpen] = useState(false);
    const [addBlockingAllow, setAddBlockingAllow] = useState(true);
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

    const defaultBlocking: ItemBlock = {
        idBlock: 0,
        idEquipments: [],
        idGroupTypes: [],
        idCategories: [],
        idUserTypes: [],
        idUserStatuses: [],
        jsonBlock: {
            startDate: "",
            endDate: "",
            startTime: "",
            endTime: "",
            weekDays: [],
        },
        reason: "",
        block: "",
    };

    const [blockings, setBlockings] = useState<ItemBlock[]>([]);
    const [blocking, setBlocking] = useState<ItemBlock>();

    useEffect(() => {
        const handleHashChange = () => {
            const hash = window.location.hash;
            const params = new URLSearchParams(hash.split("?")[1]);
            const id = params.get("id");

            if (id === null)
                handleRefreshBlocks();
            else
                handleGetBlock(id ? parseInt(id) : 0);
        };

        window.addEventListener("hashchange", handleHashChange);
        // also trigger once on mount
        handleHashChange();

        return () => window.removeEventListener("hashchange", handleHashChange);
    }, []);

    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const { navigate } = useRouter();






    type ItemBlockData = {
        startDate: string,
        endDate: string,
        startTime: string,
        endTime: string,
        weekDays: number[],
    }

    type ItemBlock = {
        idBlock: number,
        //idEquipment?: number,
        idEquipments?: number[],
        //idGroupType?: number,
        idGroupTypes?: number[],
        //idCategory?: number,
        idCategories?: number[],
        //idUserType?: number,
        idUserTypes?: number[],
        //idUserStatus?: number,
        idUserStatuses?: number[],
        jsonBlock: ItemBlockData,
        isActiveBlock?: number,
        reason?: string,
        block?: string,
    }

    useEffect(() => {
        //console.log("Blocking changed", blocking);
    }, [blocking]);
    useEffect(() => {
        let block = false;
        if (blocking) {
            //console.log(blocking)
            if (blocking.block === "") block = true;
            if (blocking.reason === "") block = true;
            if (
                (blocking.idCategories && blocking.idCategories.length === 0) &&
                (blocking.idEquipments && blocking.idEquipments.length === 0) &&
                (blocking.idGroupTypes && blocking.idGroupTypes.length === 0) &&
                (blocking.idUserTypes && blocking.idUserTypes.length === 0) &&
                (blocking.idUserStatuses && blocking.idUserStatuses.length === 0)
            ) block = true;
            setAddBlockingAllow(block)
        } else {
            setAddBlockingAllow(true)
        }

    }, [blocking]);


    const labels = [
        { id: 1, label: "L" }, // Lunes
        { id: 2, label: "M" }, // Martes
        { id: 3, label: "M" }, // Miércoles
        { id: 4, label: "J" }, // Jueves
        { id: 5, label: "V" }, // Viernes
        { id: 6, label: "S" }, // Sábado
        { id: 7, label: "D" }, // Domingo
        { id: 0, label: "F" }, // Feriados
    ];


    const handleDeleteBlocking = async () => {
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/parameters/blocks/delete',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({ idBlock: blocking?.idBlock }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                window.location.hash = "#masters/parameters/blockings"

            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally {
            setLoading(false)
        }
    }
    const handleGetBlock = async (id: number) => {
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/parameters/blocks/get',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({ idBlock: id }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                setBlockings([])
                setBlocking(data.blocking)
            }
        } catch (error: any) {

            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally {
            setLoading(false)
        }
    }
    const handleRefreshBlocks = async () => {
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/parameters/blocks/list',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({}),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                setBlockings(data.blockings)
                setBlocking(undefined)

            }
        } catch (error: any) {

            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally {
            setLoading(false)
        }
    }
    const handleUpdateBlocking = async () => {
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/parameters/blocks/update',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify(blocking),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                window.location.hash = "#masters/parameters/blockings"

            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally {
            setLoading(false)
        }
    }

    return (
        <CustomAppLayout
            toolsHide
            splitPanelOpen={sideOpen}
            onSplitPanelToggle={({ detail }) => setSideOpen(detail.open)}


            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>
                    {blockings && blockings.length > 0 && (
                        <SpaceBetween direction="vertical" size="xs">
                            <Header variant='h2' actions={
                                <SpaceBetween direction="horizontal" size="xs">
                                    <Button onClick={() => {
                                        setBlockings([]);
                                        setBlocking(defaultBlocking);

                                    }}>Agregar</Button>
                                    <Favorites />
                                </SpaceBetween>
                            }>
                                Bloqueos
                            </Header>

                            <Table
                                variant="embedded"
                                onRowClick={(row) => {
                                    window.location.hash = `#masters/parameters/blockings?id=${row.detail.item.idBlock}`
                                }}
                                columnDefinitions={[
                                    {
                                        id: "block",
                                        header: "Bloqueo",
                                        cell: item => {
                                            const labels = [
                                                { id: 1, label: "L" }, { id: 2, label: "M" }, { id: 3, label: "M" }, { id: 4, label: "J" }, { id: 5, label: "V" }, { id: 6, label: "S" }, { id: 7, label: "D" }, { id: 0, label: "F" },
                                            ];

                                            // Determinar qué días están activos (bloqueados)
                                            const activeDays = Array.isArray(item?.jsonBlock?.weekDays) ? item.jsonBlock.weekDays : [];

                                            // Filtrar las etiquetas para mostrar solo los días activos
                                            const activeLabels = labels.filter(day => activeDays.includes(day.id));

                                            return (
                                                // FormField and Badge must be imported from Cloudscape or defined locally
                                                <FormField label={
                                                    <>
                                                        {item?.block}
                                                    </>}>
                                                    <div style={{ display: 'flex', gap: '1px' }}>
                                                        {activeLabels.length > 0 ? (
                                                            activeLabels.map(day => (
                                                                <BadgeCustom size='small' bold={false} key={day.id} color="blue">
                                                                    {day.label}
                                                                </BadgeCustom>
                                                            ))
                                                        ) : (
                                                            <span style={{ color: '#6b7280' }}>-</span>
                                                        )}
                                                    </div>
                                                </FormField>
                                            );
                                        }
                                    },
                                    {
                                        id: "days",
                                        header: "Validez",
                                        cell: item => (<>

                                            {item?.jsonBlock?.startDate === ""
                                                ? <Icon path={mdiAllInclusiveBox} size={1} />
                                                : item?.jsonBlock?.startDate}
                                            {<Icon path={mdiArrowRightThin} size={1} />}
                                            {item?.jsonBlock?.endDate === ""
                                                ? <Icon path={mdiAllInclusiveBox} size={1} />
                                                : item?.jsonBlock?.endDate}
                                        </>),

                                    },
                                    {
                                        id: "jsonBlocking",
                                        header: "Horarios",
                                        cell: item => (<>
                                            {item?.jsonBlock?.startTime === ""
                                                ? <Icon path={mdiAllInclusiveBox} size={1} />
                                                : item?.jsonBlock?.startTime}

                                            {<Icon path={mdiArrowRightThin} size={1} />}
                                            {item?.jsonBlock?.endTime === ""
                                                ? <Icon path={mdiAllInclusiveBox} size={1} />
                                                : item?.jsonBlock?.endTime}
                                        </>
                                        )
                                    },
                                    {
                                        id: "isActiveBlock",
                                        header: "",
                                        cell: item => <IconActive isActive={item?.isActiveBlock || 0} size={1} />,
                                        width: 50,
                                    },
                                ]}
                                trackBy="idBlock"
                                items={blockings ?? []}
                                empty={
                                    <Box
                                        margin={{ vertical: "xs" }}
                                        textAlign="center"
                                        color="inherit"
                                    >
                                        <SpaceBetween size="m">
                                            <b>Sin bloqueos activos</b>
                                        </SpaceBetween>
                                    </Box>
                                }
                            />
                        </SpaceBetween>
                    )
                    }
                    {
                        blocking && (
                            <SpaceBetween direction="vertical" size="xs">
                                <Header variant='h2' actions={<SpaceBetween direction="horizontal" size="xs">

                                    <Button variant='link' onClick={() => {
                                        if (blocking?.idBlock && blocking.idBlock > 0) {
                                            window.location.hash = "#masters/parameters/blockings"
                                            return
                                        }

                                        setBlocking(undefined);
                                        handleRefreshBlocks()
                                        setBlockings([]);
                                    }}>Volver</Button>
                                    <Favorites /></SpaceBetween>}>Editar bloqueo</Header>
                                <Form
                                    actions={
                                        <Button variant='primary' disabled={addBlockingAllow} onClick={() => handleUpdateBlocking()}>Guardar bloqueo</Button>
                                    }
                                    secondaryActions={
                                        blocking?.idBlock && blocking.idBlock > 0 && (
                                            <Button style={{ root: btnWarn }} onClick={() =>
                                                setShowDeleteConfirm(true)
                                            }>Eliminar</Button>
                                        )}>
                                    <FormField label="Glosa interna" constraintText={`Obligatorio`}
                                        info={
                                            <Checkbox
                                                checked={blocking?.isActiveBlock === 1}
                                                onChange={(detail) => {
                                                    setBlocking((prev) => ({ ...prev, isActiveBlock: detail.detail.checked ? 1 : 0 } as ItemBlock));
                                                }}

                                            >Activo</Checkbox>}
                                    >
                                        <Input placeholder='Indentificardor del bloqueo' value={blocking?.block || ""} onChange={(event) => {
                                            setBlocking((prev) => ({ ...prev, block: event.detail.value } as ItemBlock));
                                        }} />
                                    </FormField>
                                    <FormField label="Glosa pública" constraintText="Obligatorio">
                                        <Input
                                            placeholder='Razón que se le indica al usuario'
                                            value={blocking?.reason || ""} onChange={(event) => {
                                                setBlocking((prev) => ({ ...prev, reason: event.detail.value } as ItemBlock));
                                            }} />
                                    </FormField>

                                    <SpaceBetween direction="vertical" size="xs">
                                        <FormField label="Fecha de inicio" constraintText="Fecha y hora opcional">
                                            <SpaceBetween direction="horizontal" size="xs">
                                                <DPModal date={blocking?.jsonBlock.startDate} onConfirm={(date) => {
                                                    if (date)
                                                        setBlocking((prev) => {
                                                            if (!prev) return prev;
                                                            return { ...prev, jsonBlock: { ...prev.jsonBlock, startDate: date } } as ItemBlock;
                                                        });

                                                }} />
                                                <TimeInput
                                                    format="hh:mm"
                                                    value={blocking?.jsonBlock.startTime || ""} onChange={(e) => {
                                                        setBlocking((prev) => {
                                                            if (!prev) return prev;
                                                            return { ...prev, jsonBlock: { ...prev.jsonBlock, startTime: e.detail.value } } as ItemBlock;
                                                        });
                                                    }} />
                                            </SpaceBetween>
                                        </FormField>

                                        <FormField label="Fecha de término" constraintText="Fecha y hora opcional">

                                            <SpaceBetween direction="horizontal" size="xs">
                                                <DPModal date={blocking?.jsonBlock.endDate} onConfirm={(date) => {
                                                    setBlocking((prev) => {
                                                        if (!prev) return prev;
                                                        return { ...prev, jsonBlock: { ...prev.jsonBlock, endDate: date } } as ItemBlock;
                                                    });

                                                }} />
                                                <TimeInput
                                                    format="hh:mm"
                                                    value={blocking?.jsonBlock.endTime || ""} onChange={(e) => {
                                                        setBlocking((prev) => {
                                                            if (!prev) return prev;
                                                            return { ...prev, jsonBlock: { ...prev.jsonBlock, endTime: e.detail.value } } as ItemBlock;
                                                        });
                                                    }} />
                                            </SpaceBetween>
                                        </FormField>

                                    </SpaceBetween>


                                    <SpaceBetween direction="horizontal" size="xs">
                                        <FormField label="Días" constraintText="Opcional">
                                            <SpaceBetween direction="horizontal" size="xs">
                                                {weekDays.map((day) => (
                                                    <Checkbox
                                                        key={day.value}
                                                        checked={blocking?.jsonBlock.weekDays?.includes(Number(day.value)) || false}
                                                        onChange={({ detail }) => {
                                                            setBlocking((prev) => {
                                                                if (!prev) return prev;
                                                                const dayValue = Number(day.value);

                                                                const updatedDays = detail.checked
                                                                    ? Array.from(new Set([...(prev.jsonBlock.weekDays || []), dayValue]))
                                                                    : (prev.jsonBlock.weekDays || []).filter((d) => d !== dayValue);

                                                                return {
                                                                    ...prev,
                                                                    jsonBlock: {
                                                                        ...prev.jsonBlock,
                                                                        weekDays: updatedDays,
                                                                    },
                                                                };
                                                            });
                                                        }}
                                                    >
                                                        {day.label}
                                                    </Checkbox>
                                                ))}

                                            </SpaceBetween>
                                        </FormField>


                                    </SpaceBetween>
                                    <FormField label="Aplicar a material">
                                        <SelectEquipments isBookCapable={1} value={blocking?.idEquipments || []}
                                            onConfirm={(detail) => {
                                                //console.log(detail)
                                                setBlocking((prev) => ({ ...prev, idEquipments: detail } as ItemBlock));
                                            }}
                                        />
                                    </FormField>
                                    <FormField label="Aplicar a categoria de material">

                                        <SelectCategory width={0} single={false} value={blocking?.idCategories || []}
                                            onSelect={(detail) => {
                                                //console.log(detail)
                                                setBlocking((prev) => ({ ...prev, idCategories: detail } as ItemBlock));
                                            }} />
                                    </FormField>
                                    <FormField label="Aplicar a grupo de material">
                                        <SelectGroupType width={0} single={false} showOnBooking={0} value={blocking?.idGroupTypes || []} onSelect={(detail) => {
                                            setBlocking((prev) => ({ ...prev, idGroupTypes: detail } as ItemBlock));
                                        }} />
                                    </FormField>
                                    <FormField label="Aplicar a tipo de usuario">
                                        <SelectUserType width={0} single={false} value={blocking?.idUserTypes || []} onSelect={(detail) => {
                                            setBlocking((prev) => ({ ...prev, idUserTypes: detail } as ItemBlock));
                                        }} />
                                    </FormField>
                                </Form>
                            </SpaceBetween>

                        )
                    }
                    <ConfirmDelete show={showDeleteConfirm} confirmWord={'eliminar'} action={'Eliminar'} warning={''}
                        header={'Eliminar bloqueo de material'}
                        subtitle='Verificación de eliminación'
                        onDismiss={() => setShowDeleteConfirm(false)}
                        onConfirm={() => handleDeleteBlocking()}

                    />

                </>
            }
        />
    );
};